import { getSampleButtonText, shouldDisabledSampleButton } from '../product-samples/product-samples';
import QuickShopClass from './product-quickshop';

export const ToggleQuickshopSidebar = {
  name: 'toggle-quickshop',
  template: `<button v-if="availableForQuickshop" class="cta-button mb-3" :class="classNames" @click="addToQuickshop(productHandle)">
    <p class="cta-button__text">{{ text }}</p>
  </button>`,
  props: ['productHandle', 'productTags', 'productKitWeight', 'productKit', 'productId', 'productHandle', 'productTags', 'isSample', 'sampleVariantIds'],
  data() {
    return {
      availableForQuickshop: true,
    };
  },
  mounted() {
    this.isProductAvailableForQuickshop(this.productTags);
  },
  methods: {
    addToQuickshop: function (handle) {

      const text = getSampleButtonText(this.productId, this.productKit, this.productKitWeight, this.sampleVariantIds);
      const disabled = shouldDisabledSampleButton(text);

      if (!this.isSample) {
        QuickShopClass.getInstance().addToQuickshop(handle);
      } else if (!disabled) {
        QuickShopClass.getInstance().addToQuickshop(handle, true, {
          sampleWeight: this.productKitWeight,
          sampleKit: this.productKit,
          sampleVariantId: this.productId,
          sampleHandle: this.productHandle,
          sampleTags: this.productTags,
          sampleVariantIds: this.sampleVariantIds,
        });
      }
    },
    isProductAvailableForQuickshop: function (tags) {
      if (!this.isSample) {
        const tagArray = tags.split(',');
        const hideQuickshopCTA = tagArray.find(
          (tag) => tag === 'disable_quickshop'
        );
        hideQuickshopCTA
          ? (this.availableForQuickshop = false)
          : (this.availableForQuickshop = true);
      } else {
        const tagsArray = tags.split(',');
        const hideSampingCTA = tagsArray.find(
          (tag) => tag === 'disable_product_samples'
        );
        // disable button primary if disable_product_samples tag is found or otherwise disabled when no sample data found
        if (hideSampingCTA) {
          this.availableForQuickshop = false;
        } else {

          this.availableForQuickshop = !!this.productId && !!this.productHandle;
        }
      }
    },
  },
  computed: {
    text() {
      if (this.isSample) {
        const text = getSampleButtonText(this.productId, this.productKit, this.productKitWeight);
        return text;
      }
      return 'Quick Shop';
    },
    classNames() {
      if (this.isSample) {
        const text = getSampleButtonText(this.productId, this.productKit, this.productKitWeight);
        return `add-to-samples-cta ${shouldDisabledSampleButton(text) ? 'cta-button--disabled' : ''}`;
      }
      return 'cta-button--blue';
    },
  },
};
